import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationsStyles = createGlobalStyle`
  @font-face {
       font-family: 'CustomArial';
       src: url(${CustomArial});
   }
  
  .generated-images-holder-var22 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var22 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
    
  }

  .image-var22 {
    width: 50%;
    height: 100%;
    object-fit: cover;
    position: relative;
    display: block;
  }

  .text-var22 {
    position: absolute;
    width: calc(50% - 6px);
    padding: 0 20px;
    bottom: 34px;
    line-height: 1.12;
    letter-spacing: 1.2px;
    text-align: center;
    font-weight: 700;
    color: #e1e142;
    font-family: CustomArial;
    text-shadow:
    4px 0 black,
   -4px 0 black,
    0 4px black,
    0 -4px black,
    4px 4px black,
   -4px -4px black,
    4px -4px black,
   -4px 4px black;
    p {
      display: inline-block;
      margin: 0;
    }
    p.custom-brakes {
      white-space: nowrap;
    }
  }

   .break-var22 {
    position: absolute;
    width: 12px;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
  }
  
  
  .left-actual-photo-var22 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .left-actual-photo-var22--top {
    top: 0;
    bottom: auto;
  }
  .right-actual-photo-var22 {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 72px;
  }
  .right-actual-photo-var22--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
